import ChartBarNegative from './ChartBarNegative';

export default ChartBarNegative;
